import Utils from "@/utilities/Utils";
import { mapData } from "@/utilities/DataMapping";
import { IResource, Resource } from "@/model/Resource";

export interface IPathway {
    id: string;
    briefingID: string;
    description: string;
    allowedWrongAnswers: number;
    emailAttachmentResourceID: number;
    emailAttachmentInfoText: string;
    copiedFromID: string;
    created: Date;
    createdByUserID: string;
    lastUpdated: Date;
    lastUpdatedByUserID: string;
    deleted: Date;
    deletedByUserID: string;

    emailAttachmentResource: IResource;
}

export class Pathway implements IPathway {

    constructor(data?: IPathway) {
        if (data) this.update(data);
    }

    update(data: IPathway): Pathway {
        mapData(data, {
            root: () => this,
            emailAttachmentResource: (data: IResource) => this.emailAttachmentResource.update(data)
        });
        return this;
    }

    id: string = Utils.emptyGuidValue;
    briefingID: string = Utils.emptyGuidValue;
    description: string = "";
    allowedWrongAnswers: number = 0;
    emailAttachmentResourceID: number = 0;
    emailAttachmentInfoText: string = "";
    copiedFromID: string = Utils.emptyGuidValue;
    created: Date = new Date(Utils.emptyDateValue);
    createdByUserID: string = Utils.emptyGuidValue;
    lastUpdated: Date = new Date(Utils.emptyDateValue);
    lastUpdatedByUserID: string = Utils.emptyGuidValue;
    deleted: Date = new Date(Utils.emptyDateValue);
    deletedByUserID: string = Utils.emptyGuidValue;

    emailAttachmentResource = new Resource();

    hasSelectedPage: boolean = false;

    get isNew() {
        return Utils.isEmptyId(this.id);
    }
}